import {
  inferredAlaskaHawaiiDomesticDepartureLeg,
  isAlaskaHawaiiDepartureToContiguous48,
  isAlaskaOrHawaiiIcao,
  isUsDomesticIcao,
} from "./akhiIcao";
import { normIcao } from "./airportFrequencyLocal";
import {
  isForeignForeignAirLeg,
  isInternationalFacilityRoute,
} from "./usInternationalAirLeg";
import type { FlightLeg } from "./types";

/**
 * Short label for which passenger excise “bucket” this leg’s **route geometry** maps to
 * (matches worksheet: intl vs domestic; AK→<code>K…</code> stacks No. 26 + No. 27).
 */
export function passengerExciseRouteRuleLabel(leg: FlightLeg): string {
  if (leg.excludeFrom720) return "Skip 720";

  const from = leg.fromIcao;
  const to = leg.toIcao;
  const nFrom = normIcao(from);

  if (isForeignForeignAirLeg(from, to)) return "Intl–Intl → 0";

  if (isInternationalFacilityRoute(from, to)) return "U.S.↔foreign → Intl";

  if (isAlaskaHawaiiDepartureToContiguous48(from, to)) {
    return "AK/HI→K… → No. 27 + No. 26";
  }

  if (inferredAlaskaHawaiiDomesticDepartureLeg(from, to)) {
    return "AK/HI→PA/PH → No. 27 only";
  }

  /** Contiguous-style U.S. ICAO (`K…`) into Alaska/Hawaii — domestic segment on this leg (not AK departure). */
  if (
    nFrom.startsWith("K") &&
    isAlaskaOrHawaiiIcao(to) &&
    isUsDomesticIcao(to)
  ) {
    return "Dom→AK/HI → Dom";
  }

  if (isUsDomesticIcao(from) && isUsDomesticIcao(to)) return "U.S. domestic → Dom";

  return "Other → —";
}
